

import React, { Component, } from 'react';
import {Modal, ModalHeader, ModalBody, Card, CardBody, ModalFooter} from 'reactstrap';
import VoucherCodeDialogue from './VoucherCodeDialogue'
import OpenDiscount from './OpenDiscount'

const viewUtil = require('../../../../utils/view/viewUtil');
const stringUtil = require('../../../../utils/string/stringUtil');
const staffAccessUtility = require('../../../../utils/domain/staff/staffAccessUtility');
const stateManager = require('../../../../utils/state/stateManager');
const formatter = require('../../../../utils/formatter/formatter.js');
var constants = require('../../../../utils/domain/constants.js');
var translator = require('../../../../utils/translator/translator');
var controlSettingsUtils = require('../../../../utils/domain/settings/controlSettingsUtils');

class SaleDiscountDialogue extends Component
{
    constructor(props)
    {
        super(props);

        this.renderDiscountOptionsDialogue = this.renderDiscountOptionsDialogue.bind(this);
        this.renderVoucherCodeDialogue = this.renderVoucherCodeDialogue.bind(this);
        this.renderOpenDiscountDialogue = this.renderOpenDiscountDialogue.bind(this);

        this.onEnterVoucherCode = this.onEnterVoucherCode.bind(this);
        this.onOpenDiscount = this.onOpenDiscount.bind(this);

        this.state = {};
        this.state.showVoucherCodeDialogue = false;
        this.state.showOpenDiscountDialogue = false;
    }

    render()
    {
        if (this.state.showVoucherCodeDialogue)
            return this.renderVoucherCodeDialogue();

        if (this.state.showOpenDiscountDialogue)
            return this.renderOpenDiscountDialogue();

        return this.renderDiscountOptionsDialogue();
    }

    renderDiscountOptionsDialogue()
    {
        var components = [];

        stateManager.getStore().getState().discountOffers.forEach(offer => 
        {
            if(offer.isEnabled && offer.isAvailable)
            {
                var discountValue;

                if(offer.discountOfferType == constants.DiscountOfferTypes.Fixed)
                    discountValue = `${formatter.convertToCurrencyFormat(offer.value)}`
                else if (offer.discountOfferType == constants.DiscountOfferTypes.Percentage)
                    discountValue = `${formatter.roundUp(offer.value, 2)}%`;                

                components.push(<div onClick={()=>{this.props.onDiscount(offer)}}>
                                    <Card style={{marginTop:'0px', marginBottom:'5px', background:'#DCDCDC', color:'#484848'}}>
                                        <CardBody style={{padding:'15px 10px 5px 10px'}}>
                                            <table width="100%">
                                                <tr >
                                                    <td colSpan="2">
                                                        <div style={{marginBottom:'10px', textAlign:'center', color:'var(--colors-primary)'}}>{offer.code}</div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div className="text-muted" style={{marginTop:'0px', textAlign:'left'}}>
                                                            <small>{translator.getLabel("minimum_order_amount")}: {formatter.convertToCurrencyFormat(offer.minimumOrderAmount)}</small>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="text-muted" style={{marginTop:'0px', textAlign:'right'}}>
                                                            <small>{translator.getLabel("discount")}: {discountValue}</small>
                                                        </div>
                                                    </td>                                                
                                                </tr>
                                            </table>
                                        </CardBody>
                                    </Card>
                                </div>);
            }
        })

        components.push(<div onClick={this.onEnterVoucherCode}>
                            <Card style={{marginTop:'0px', marginBottom:'5px', background:'var(--colors-primary)', color:"#F0F0F0"}}>
                                <CardBody><div style={{marginTop:'5px', textAlign:'center'}}>{translator.getLabel("voucher_code")}</div></CardBody>
                            </Card>
                        </div>);


        if (controlSettingsUtils.getAllowOpenDiscounts())
        {
            components.push(<div onClick={this.onOpenDiscount}>
                                <Card style={{marginTop:'0px', marginBottom:'5px', background:'var(--color-warn)', color:"#F0F0F0"}}>
                                    <CardBody><div style={{marginTop:'5px', textAlign:'center'}}>{translator.getLabel("open_discount")}</div></CardBody>
                                </Card>
                            </div>);
        }

        components.push(<div onClick={this.props.onRemoveDiscount}>
                            <Card style={{marginTop:'0px', marginBottom:'5px', background:'var(--colors-error)', color:"#F0F0F0"}}>
                                <CardBody><div style={{marginTop:'5px', textAlign:'center'}}>{translator.getLabel("remove_discount")}</div></CardBody>
                            </Card>
                        </div>);

        return(<div style={{userSelect:'none'}}>
                    <Modal  isOpen={true} centered animation={false} fade={false}
                            toggle={()=>{this.props.onCancel()}}>
                        <ModalHeader cssModule={{ 'modal-title': 'w-100' }} style={{background:'var(--background-color)', paddingBottom:'5px'}}>
                            <div className="caption primary-color d-flex justify-content-center">
                                {translator.getLabel("discount_options")}
                            </div>
                        </ModalHeader>
                        {this.getNotesComponent()}
                        <ModalBody style={{margin:'-10px'}}>
                            <div style={{ overflowX: "hidden", overflowY: "auto", maxHeight: "70vh" }}>{components}</div>
                        </ModalBody>

                    </Modal>
                </div>);
    }

    getNotesComponent()
    {
        let saleContext = this.props.saleContext;
        
        if (saleContext.selectedItems.length <= 0)
            return <div style={{textAlign:'center', marginTop:'6px', marginBottom:'5px', color:'var(--colors-text-light)'}}><small>{translator.getLabel("discount_will_be_applied_on_complete_order")}</small></div>

        var selectedItem = saleContext.selectedItems[0];
        return <div style={{textAlign:'center', marginTop:'6px', marginBottom:'5px', color:'var(--colors-text-light)'}}><small>{translator.getLabel("apply_discount_on")} <b>{selectedItem.caption}</b></small></div>
    }


    renderVoucherCodeDialogue()
    {
        return <VoucherCodeDialogue 
                    onCancel = {()=>
                    {
                        this.props.onCancel()
                    }}
                    handleSubmit={(voucherCode) =>
                    {
                        this.props.onVoucher(voucherCode);
                    }}/>
    }

    renderOpenDiscountDialogue()
    {
        return <OpenDiscount
                    onCancel = {()=>
                    {
                        this.props.onCancel()
                    }}
                    onSubmit={(openDiscount) =>
                    {
                        let discount = {};
                        discount.code = openDiscount.code;
                        discount.discountOfferType = openDiscount.type == "percentage" ? constants.DiscountOfferTypes.Percentage : constants.DiscountOfferTypes.Fixed;
                        discount.value = openDiscount.amount;
                        discount.minimumOrderAmount = 0;
                        
                        if (discount.discountOfferType == constants.DiscountOfferTypes.Fixed)
                        {
                            if (!staffAccessUtility.canStaffIssueFixedDiscount(this.props.staff, discount.value))
                            {
                                viewUtil.showErrorAlert(translator.getLabel("you_do_not_have_sufficient_privileges_to_issue_a_discount"));
                                this.props.onCancel();
                                return;
                            }
                        }
                        else
                        {
                            if (!staffAccessUtility.canStaffIssuePercentageDiscount(this.props.staff, discount.value))
                            {
                                viewUtil.showErrorAlert(translator.getLabel("you_do_not_have_sufficient_privileges_to_issue_a_discount"));
                                this.props.onCancel();
                                return;
                            }
                        }
                        

                        this.props.onDiscount(discount);
                    }}/>
    }

    onEnterVoucherCode()
    {
        this.state.showVoucherCodeDialogue = true;
        this.setState({});
    }

    onOpenDiscount()
    {
        this.state.showOpenDiscountDialogue = true;
        this.setState({});
    }
}

export default SaleDiscountDialogue;